import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from 'components/BaseComponent';

import { Bars, SortDown, SortUp } from '../../../components/Icon';
import { VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectKanbanColumnSort } from '../selectors';
import { setKanbanColumnSort } from '../actions';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div``;

const STATE = {
  sort: false,
};

/* eslint-disable react/prefer-stateless-function */
class KanbanColumnFilterComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get currentSortByName() {
    return (this.props.sort?.[0] || {}).sortBy;
  }

  get currentSortByDesc() {
    return (this.props.sort?.[0] || {}).desc;
  }

  setTo(name) {
    let current = this.props.sort?.[0] || {};
    this.props.setTo(name, !current.desc);
  }

  render() {
    return (
      <Container>
        <ButtonComponent size={'btn-sm'} style={'ButtonSoftPrimary'} onClick={this.setStateFn({ sort: !this.state.sort })}>
          <Bars />
        </ButtonComponent>

        {this.state.sort ? this.renderModal() : null}
      </Container>
    );
  }

  renderModal() {
    let sortTypes = [
      'id',
      'regplate',
      'vin',
      'counter',
      'transport_outgoing_assigned_to',
      'transport_assigned_to',
      'transport_from_address_postcode',
      'transport_to_address_postcode',
      ,
    ];

    if (env.clientId === AppClientId.HILTERMANN) {
      sortTypes = ['TransportDatum', 'category_id'];
    }
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanbanColumnFilter.title')} buttonWidth={'400px'}>
        <VBox center vCenter gap={12}>
          <div>Sort by:</div>

          {sortTypes.map(name => (
            <ButtonComponent
              style={name == this.currentSortByName ? 'ButtonSoftPrimaryGreenFullWidth' : 'ButtonSoftPrimaryFullWidth'}
              onClick={() => this.setTo(name)}
              key={name}
            >
              {this.currentSortByName == name ? this.currentSortByDesc ? <SortDown /> : <SortUp /> : null}&nbsp;
              {this.lbl(`vehicle.property.${name}`)}
            </ButtonComponent>
          ))}
        </VBox>
        <div className="mt-2 d-flex justify-content-center">
          <ButtonComponent style={'ButtonSoftEdit'} onClick={this.reset.bind(this)}>
            {this.lbl('confirm')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}
KanbanColumnFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};
const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    sort: selectKanbanColumnSort(ownProps.column.id),
  });
function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setTo(sortBy, desc, callback) {
      dispatch(setKanbanColumnSort(ownProps.column.id, sortBy, desc));
    },
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const KanbanColumnFilter = compose(withConnect, withRouter)(KanbanColumnFilterComp);
